import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { db } from "../firebase";
import { collection, query, where, limit, getDocs } from "firebase/firestore";
import NotFoundLayout from "../layouts/not_found_layout"; // adjust path as needed
import { logger } from '../utils/logger';

const NotFound = () => {
  const location = useLocation();
  const [resolvedEvent, setResolvedEvent] = useState(null);

  const possibleSlug = location.pathname
    .split("/")
    .filter(Boolean)[0] || "";

  useEffect(() => {
    // A missing route is an expected navigation outcome, not an actionable
    // application failure, so it remains a console-only diagnostic.
    logger.log("📄 Page not found", { path: location.pathname });
  }, [location.pathname]);

  useEffect(() => {
    const resolveEventFromPath = async () => {
      if (!possibleSlug) return;

      try {
        const slugQuery = query(
          collection(db, "events"),
          where("slug", "==", possibleSlug),
          limit(1)
        );

        const snap = await getDocs(slugQuery);

        if (!snap.empty) {
          setResolvedEvent({
            id: snap.docs[0].id,
            ...snap.docs[0].data(),
          });
        }
      } catch (err) {
        logger.warn("⚠️ Could not resolve event slug from 404 path:", {
          value: err,
        });
      }
    };

    resolveEventFromPath();
  }, [possibleSlug]);

  return (
    <NotFoundLayout>
    <section id="top-content" className="container-fluid py-5">
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5 text-danger">🚫 404 – Page Not Found</h1>
          <p className="lead text-muted">
            We couldn’t find the page you were looking for.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white text-center">
        <p className="mb-4">
          It’s possible the link is broken or the page has moved.

          <p className="small text-muted">
            Requested URL: {location.pathname}
          </p>

        </p>

        {resolvedEvent?.slug ? (
          <Link
            to={`/${resolvedEvent.slug}`}
            className="btn btn-primary btn-lg"
          >
            🔙 Take Me to {resolvedEvent.name || "Event"}
          </Link>
        ) : (
          <Link
            to="/dashboard"
            className="btn btn-primary btn-lg"
          >
            🔙 Back to Dashboard
          </Link>
        )}

        <div className="mt-4 text-muted">
          <p>
            Need help?{" "}
            <a href="mailto:hello@letsgovote.app">Contact us</a> and we’ll look into it.
          </p>

          <Link to="/" className="btn btn-outline-secondary">
            🔙 Let's Go Vote Home
          </Link>

        </div>
      </div>
    </section>
    </NotFoundLayout>
  );
};

export default NotFound;
